import { combineReducers } from '@reduxjs/toolkit';

import { api } from '../api/api';
import authReducer from '../modules/auth/state/authSlice';

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  auth: authReducer
});
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
